<template>
    <b-modal id="estado-pedido-modal" no-close-on-backdrop no-close-on-esc hide-header hide-footer centered
        v-model="modalShow">
        <div class="d-flex flex-column align-items-center my-2 text-center">

            <feather-icon :icon="icon" :class="'text-' + type + ' mb-2'" size="80" />

            <h3 class="text-center">{{ title }}</h3>
            <span class="text-center">{{ message }}</span>

            <b-button variant="custom-blue" class="mt-2" @click="confirmRedirect">
                Entendido
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import { BModal, BButton } from "bootstrap-vue";

export default {
    components: { BModal, BButton },

    props: {
        modalShow: Boolean,
        state: String,
    },

    computed: {
        type() {
            return this.state === "removido" ? "danger" : "warning";
        },
        icon() {
            return this.state === "removido" ? "XCircleIcon" : "AlertTriangleIcon";
        },
        title() {
            return {
                expirado: "Prazo encerrado",
                removido: "Adesão removida",
            }[this.state];
        },
        message() {
            return {
                expirado:
                    "O prazo de 48 horas se encerrou. Esta adesão em rascunho foi automaticamente encerrada.",
                removido:
                    "Esta adesão em rascunho foi removida.",
            }[this.state];
        },
    },

    methods: {
        confirmRedirect() {
            this.$emit("close");
        },
    },
};
</script>
